/**
 * @classdesc
 * Klasse, die die Hintergrundlayer anhand der Konfiguration initialisiert.
 *
 * @class
 * @extends Object
 * @memberof gc.gis.map
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.map.GCMapView} mapView
 * @param {gc.gis.util.GCRequestManager} requestManager
 * @param {gc.gis.factory.ObjectFactory} mapFactory
 * @param {Array} backgroundLayerConfiguration
 */
gc.gis.map.GCBackgroundLayerInitiator = function (mapView, requestManager, mapFactory, backgroundLayerConfiguration)
{
    this._mapView = mapView;
    this._requestManager = requestManager;
    this._mapFactory = mapFactory;
    this._configuration = backgroundLayerConfiguration;

    this._wmtsProvider = this._mapFactory.createWMTSProvider(this._requestManager);
    this._wmsProvider = this._mapFactory.createWMSProvider(this._requestManager, this._mapView.getMap());

    this._initBackgroundLayers();
};


gc.gis.map.GCBackgroundLayerInitiator.prototype._initBackgroundLayers = function()
{
    const self = this;
    const layerLoader = function(layerSettings, index) {
        if ('wmts' === layerSettings.type)
        {
            self._initWmtsBackgroundLayer(layerSettings, index);
        }
        else if ('wms' === layerSettings.type)
        {
            self._initWmsBackgroundLayer(layerSettings, index);
        }
    }

    this._configuration.forEach(layerLoader);
};

gc.gis.map.GCBackgroundLayerInitiator.prototype._initWmtsBackgroundLayer = function(layerSettings, index)
{
    const self = this;
    this._wmtsProvider.getCapabilities(layerSettings.url, cap => {
        const options = {
            matrixSet: layerSettings.matrixSet
        };

        const layerConfig = self._wmtsProvider.getLayerConfig(cap, layerSettings.identifier, options);
        self._loadLayerOnMap(layerConfig, layerSettings, index);
    });
};

gc.gis.map.GCBackgroundLayerInitiator.prototype._initWmsBackgroundLayer = function(layerSettings, index)
{
    const self = this;
    this._wmsProvider.getCapabilities(layerSettings.url, cap => {
        const layerConfig = self._wmsProvider.getLayerConfig(cap, [layerSettings.name], [], {
            format: 'image/png',
            tiled: true,
            preferredCRS: layerSettings.crs
        });
        layerConfig.cached = true;	// in Zusammenspiel mit tiled = true erfolgt das Laden ohne Sperrung der Oberfläche

        self._loadLayerOnMap(layerConfig, layerSettings, index);
    });
};

gc.gis.map.GCBackgroundLayerInitiator.prototype._loadLayerOnMap = function(layerConfig, layerSettings, index)
{
    layerConfig.label = layerSettings.label || layerConfig.label;
    layerConfig.abstract = layerSettings.abstract || layerConfig.abstract;
    layerConfig.attribution = layerSettings.attribution || layerConfig.attribution;
    layerConfig.visible = 0 === index;

    this._mapView.loadBackgroundLayer(layerConfig, index, layerSettings.previewClassName, layerSettings.previewImage);
};